export default __webpack_public_path__ + "static/media/pacman.1e7c32ff.gif";